import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableSortLabel,
  Tooltip
} from "@material-ui/core";

import { useStore } from "@store/store";
import Pagination from "@components/pagination";
import { impactedInvoicesListingHeader, rowsPerPageVal } from "@utils/constant";
import Row from "./row";
import { TableStyle } from "./style";

function TableListing(props) {
  const { getImpactInvoiceBySurchargeBackDatedEventId } = props;
  const classes = TableStyle();
  const [state] = useStore();
  const [pagination, setPagination] = useState({
    page: 0,
    size: rowsPerPageVal
  });
  const [sort, setSort] = useState({
    order: "DESC",
    orderBy: "invoice"
  });
  let data = state?.customer?.impactInvoiceData?.rows || [];
  let count = state?.customer?.impactInvoiceData?.count ?? 0;

  const handleChangePage = (event, newPage) => {
    setPagination((prev) => (
      {
        ...prev,
        page: newPage
      }
    ));
    const payload = {
      ...pagination,
      ...sort,
      page: newPage + 1
    };
    getImpactInvoiceBySurchargeBackDatedEventId(payload);
  };

  const handleChangeRowsPerPage = (event) => {
    setPagination(prev => (
      {
        ...prev,
        size: parseInt(event.target.value, 10),
        page: 0
      }
    ));

    const payload = {
      ...pagination,
      ...sort,
      page: 1,
      size: parseInt(event.target.value, 10),
    };
    getImpactInvoiceBySurchargeBackDatedEventId(payload);
  };

  const handleSorting = (event, property) => {
    const isAsc = sort.orderBy === property.sortTitle && sort.order === "asc";
    setSort(prev => (
      {
        ...prev,
        order: isAsc ? "desc" : "asc",
        orderBy: property.sortTitle
      }
    ));
    resetPagination();
    const payload = {
      page: 1,
      size: rowsPerPageVal,
      order: isAsc ? "desc" : "asc",
      orderBy: property.sortTitle
    };
    getImpactInvoiceBySurchargeBackDatedEventId(payload);
  }

  const resetPagination = () => {
    setPagination(prev => (
      {
        ...prev,
        page: 0,
        rowsPerPage: rowsPerPageVal
      }
    ));
  };
  return (
    <div className={classes.TableWrapper}>
      <TableContainer component={Paper} className={classes.customTable}>
        <Table stickyHeader aria-label="simple table">
          <TableHead>
            <TableRow>
              {impactedInvoicesListingHeader?.map((item, index) => {
                return (
                  <TableCell className={item.className} key={index}>
                    {item?.className === "invoiceDate" ? (
                      <Tooltip title={item.tooltipMessage} arrow placement="top">
                        <span>{item.title}</span>
                      </Tooltip>
                    ) : (
                      <span>{item.title}</span>
                    )}
                    {item.sort && (
                      <TableSortLabel
                        direction={
                          sort.orderBy === item.sortTitle ? sort.order : "desc"
                        }
                        active={true}
                        onClick={(e) => handleSorting(e, item)}
                      />
                    )}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, id) => {
              return (
                <Row
                  key={id}
                  row={row}
                  index={id}
                  timezone={props.timezone}
                  listNewInvoiceDateMap={props.listNewInvoiceDateMap}
                  handleChangeInvoiceDate={props.handleChangeInvoiceDate}
                  registerErrorRef={props.registerErrorRef}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {count !== 0 && (
        <div className="pagination-wrapper">
          <Pagination
            count={count}
            page={pagination.page}
            handleChangePage={handleChangePage}
            rowsPerPage={pagination.size}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </div>
      )}
    </div>
  );
}

export default TableListing;
